import 'form-request-submit-polyfill';

// firefox пока не поддерживает :has https://caniuse.com/css-has
import cssHasPseudo from 'css-has-pseudo/browser';
import { enableMapSet } from 'immer';

enableMapSet();
cssHasPseudo(document);
